import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Routes from '../../components/routes/Routes';
import { StateModel, StateModel_Modal } from '../../redux/store';

import { setModalConfig } from '../../redux/actions/modal';
import Spinner from '../../components/spinner/Spinner';
import Modal from '../../components/modal/Modal';
import { setLoading } from '../../redux/actions/spinner';
import { getClientConfig } from '../../redux/actions/tt';

interface MainProps {
  modal: StateModel_Modal;
  setModalConfig: (value: any, fieldName: string) => void;
  loading: boolean;
  setLoading: (value: boolean) => void;
  getClientConfig: () => void;
}

/**
 * Main-Component
 * dient zur Darstellung des Arbeitsbereiches mit den Anwendungstabs und entsprechenden Screens als Content,
 * z.B. der Sendungsverfolgung
 *
 * @returns {JSX.Element} Main-Component
 * @constructor
 */
const Main = (props: MainProps) => {
  useEffect(() => {
    props.getClientConfig();
  }, []);

  return (
    <div className='main'>
      <Routes />
      <Modal
        show={props.modal.config?.show}
        closeHandler={() => props.setModalConfig(false, 'show')}
        closeByOutsideClick={false}
        titel={props.modal.config?.title ?? ''}
        height={props.modal.config?.height}
        width={props.modal.config?.width}
        description={props.modal.config?.description}
      >
        {props.modal.config?.children}
      </Modal>
      <Spinner setIsLoading={props.setLoading} isLoading={props.loading} />
    </div>
  );
};

const mapStateToProps = (state: StateModel) => ({
  modal: state.Modal,
  loading: state.Loading.loading,
});

export default connect(mapStateToProps, {
  setModalConfig,
  setLoading,
  getClientConfig,
})(Main);
